import React from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import { Shimmer } from '@vfgroup-oneplatform/foundation/Components';
import { shimmerPlaceholderConfig } from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import styles from './AddOnsUsersLoading.styles';
import {
  titleLoadingConfig,
  NoAssignedUsersLoadingConfig,
  footerLoadingConfig,
  assignedUsersLoadingConfig,
  unAssignedUsersLoadingConfig,
} from './AddOnsUsersLoadingConfig';

function AddOnsUsersLoading({ usersCount }) {
  const theme = useTheme();

  const renderUnassignedUsersLoading = () => {
    return (
      <Shimmer
        config={unAssignedUsersLoadingConfig}
        shimmerPlaceholderConfig={shimmerPlaceholderConfig}
      />
    );
  };
  const renderTitleLoading = () => {
    return (
      <Shimmer config={titleLoadingConfig} shimmerPlaceholderConfig={shimmerPlaceholderConfig} />
    );
  };

  const renderFooterLoading = () => {
    return (
      <Shimmer
        config={footerLoadingConfig(usersCount)}
        shimmerPlaceholderConfig={shimmerPlaceholderConfig}
      />
    );
  };
  const renderHeaderCard = () => {
    if (usersCount !== 0) {
      return (
        <Shimmer
          config={assignedUsersLoadingConfig}
          shimmerPlaceholderConfig={shimmerPlaceholderConfig}
        />
      );
    }

    return (
      <Shimmer
        config={NoAssignedUsersLoadingConfig}
        shimmerPlaceholderConfig={shimmerPlaceholderConfig}
      />
    );
  };

  return (
    <View style={styles.marginStyle(15)}>
      {renderTitleLoading()}
      <View style={styles.loadingContentStyle(theme)}>
        <View style={styles.contentPadding}>
          {renderHeaderCard()}
          {renderUnassignedUsersLoading()}
        </View>
        {renderFooterLoading()}
      </View>
    </View>
  );
}
AddOnsUsersLoading.propTypes = {
  usersCount: PropTypes.number,
};
export default AddOnsUsersLoading;
